// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2VqNO","title":"Header_title__1Fo9B","left":"Header_left__3CvqG","clinicName":"Header_clinicName__10aec"};